<template>

    <form ref="estoqueitemestagio-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="estoqueItemId">Estoque</label>
                <select v-select="{ dataitem: 'EstoqueItem', default: 'Selecione', filters: { attributeBehavior: 'somenteMaterialDidatico' }  }" v-model="model.estoqueItemId" class="form-control" name="estoqueItemId" required></select>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="obrigatorio" class="custom-control-input" v-model="model.obrigatorio">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Obrigatório?</span>
                </label>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estoqueitemestagio-form-create",
        mixins: [base],
        props: { estagioId: Number },
        data: () => ({

            model: { estoqueItemId:""},

            form: "estoqueitemestagio-form-create",

            resources: {
                create: 'estoqueitemestagio',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;
                this.model.estagioId = this.estagioId;
                debugger;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

